import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Card } from "@/components/ui/card";
import { Sparkles, Utensils, Dumbbell } from "lucide-react";

const money = (v) => `R$ ${Number(v || 0).toFixed(2).replace(".", ",")}`;

const monthOptions = () => {
  const now = new Date();
  return [0, 1, 2].map((i) => {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1);
    const v = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
    return { v, label: d.toLocaleDateString("pt-BR", { month: "long", year: "numeric" }) };
  });
};

const Stat = ({ icon: Icon, label, count, sub, cost, color, testid }) => (
  <div className="p-3 rounded-xl border border-slate-200 bg-slate-50" data-testid={testid}>
    <div className="flex items-center gap-1 text-xs font-bold" style={{ color }}><Icon className="w-3 h-3"/>{label}</div>
    <div className="font-heading text-2xl font-black mt-1 text-slate-900" data-testid={`${testid}-count`}>{count}</div>
    {sub && <div className="text-[11px] text-slate-500">{sub}</div>}
    <div className="text-xs text-slate-600 mt-1" data-testid={`${testid}-cost`}>≈ {money(cost)}</div>
  </div>
);

export const AiUsageCard = () => {
  const opts = monthOptions();
  const [month, setMonth] = useState(opts[0].v);
  const [d, setD] = useState(null);
  useEffect(() => {
    setD(null);
    api.get("/dashboard/ai-usage", { params: { month } }).then((r) => setD(r.data)).catch(() => setD({ error: true }));
  }, [month]);

  return (
    <Card className="p-5 border border-slate-200" data-testid="ai-usage-card">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <h3 className="font-heading text-lg font-bold text-slate-900 flex items-center gap-2"><Sparkles className="w-4 h-4 text-fuchsia-600"/>Uso de IA no mês</h3>
        <select value={month} onChange={(e) => setMonth(e.target.value)} className="border border-slate-200 rounded-md px-2 py-1 text-sm capitalize" data-testid="ai-usage-month">
          {opts.map((o) => <option key={o.v} value={o.v}>{o.label}</option>)}
        </select>
      </div>
      {!d ? <div className="py-6 text-center text-slate-400 text-sm">Carregando…</div>
        : d.error ? <div className="py-6 text-center text-rose-500 text-sm" data-testid="ai-usage-error">Não foi possível carregar o uso de IA</div>
        : <AiUsageBody d={d}/>}
    </Card>
  );
};

const AiUsageBody = ({ d }) => (
  <>
    <div className="grid grid-cols-3 gap-3">
      <Stat icon={Utensils} label="Dietas IA" count={d.diet.count} cost={d.diet.cost_brl} color="#10B981" testid="ai-usage-diet"/>
      <Stat icon={Dumbbell} label="Treinos IA" count={d.workout.count} sub={`${d.workout.portal} pelo aluno · ${d.workout.staff} pela equipe`} cost={d.workout.cost_brl} color="#E11D48" testid="ai-usage-workout"/>
      <div className="p-3 rounded-xl border border-fuchsia-200 bg-fuchsia-50" data-testid="ai-usage-total">
        <div className="text-xs font-bold text-fuchsia-700">Custo estimado</div>
        <div className="font-heading text-2xl font-black mt-1 text-fuchsia-700" data-testid="ai-usage-total-cost">{money(d.total_cost_brl)}</div>
        <div className="text-[11px] text-slate-500">no mês</div>
      </div>
    </div>
    {d.by_unit.length > 0 && (
      <div className="mt-3 overflow-x-auto">
        <table className="w-full text-sm" data-testid="ai-usage-by-unit">
          <thead><tr className="text-[10px] uppercase tracking-widest text-slate-500 text-left"><th className="py-1">Unidade</th><th>Dietas</th><th>Treinos</th><th className="text-right">Custo</th></tr></thead>
          <tbody>
            {d.by_unit.map((r) => (
              <tr key={r.unit} className="border-t border-slate-100"><td className="py-1.5 font-semibold text-slate-800">{r.unit}</td><td>{r.diet}</td><td>{r.workout}</td><td className="text-right">{money(r.cost_brl)}</td></tr>
            ))}
          </tbody>
        </table>
      </div>
    )}
    <p className="text-[11px] text-slate-400 mt-3">
      Estimativa: {money(d.diet.unit_cost_brl)} por dieta e {money(d.workout.unit_cost_brl)} por treino (medição real no GPT-5.4, dólar a R$ {String(d.usd_brl).replace(".", ",")}). O valor cobrado no saldo da Universal Key pode variar.
    </p>
  </>
);
